<template>
    <div class="container">
        <div class="section" :class="{
            'section-cur': index == 2,
            'section-stu': index == 5,
        }" v-for="(item, index) in imgList" :key="index">
            <img class="img" :src="item">
            <!-- <button v-if="index == 1" class="btn-more" @click="JumpFn">
                <img class="more-img" :src="buttonList.more">
            </button> -->
            <button v-if="index == 2" class="btn-more" @click="JumpFn">
                <img class="more-img" :src="buttonList.more2">
            </button>
            <div class="activityBox" v-if="activity.isShow && index == 0">
                <img class="activityImg" :src="activity.PCactiveImg">
            </div>

            <div v-if="index == 2" class="section-sw">
                <div class="title">
                    <img :src="titleList.sw">
                </div>
                <div class="swiper-container current-wrap">
                    <div class="swiper-wrapper">
                        <div v-for="item in swiperList" :key="item" class="swiper-slide">
                            <img :src="item" >
                        </div>
                    </div>
                    <div class="swiper-pagination current-pagination" />
                </div>
            </div>

            <div v-if="index == 5" class="section-student">
                <div class="title">
                    <img :src="titleList.student">
                </div>
                <div class="swiper-container student-wrap">
                    <div class="swiper-wrapper">
                        <div v-for="item in studentList" :key="item" class="swiper-slide">
                            <img :src="item" >
                        </div>
                    </div>
                    <!-- <div class="swiper-pagination student-pagination" /> -->
                </div>
            </div>
        </div>
        <!-- <div class="section">
            <img class="img" :src="imgList1[0]">
        </div>
        <div class="section-student">
            <div class="title">
                <img :src="titleList.student">
            </div>
            <div class="swiper-container student-wrap">
                <div class="swiper-wrapper">
                    <div v-for="item in studentList" :key="item" class="swiper-slide">
                        <img :src="item" >
                    </div>
                </div>
                <div class="swiper-pagination student-pagination" />
            </div>
        </div>
        <div class="section">
            <img class="img" :src="imgList1[1]">
        </div> -->
        <div v-if="showMask" class="form-mask">
            <div class="mask-content">
                <div class="mask-header">
                    <div>选择目标方向，领取干货礼包</div>
                    <div class="time">{{time}}s</div>
                </div>
                <div class="subject-content">
                    <div
                        class="subject-item"
                        :class="{'actived': item.subjectId == currentSubjectId}"
                        v-for="item in subjectList"
                        :key="item.subjectId"
                        @click="handleChangeSubject(item.subjectId)"
                    >{{ item.subjectName }}</div>
                </div>
                <div class="mask-btn" @click="handleSubmit">选好了</div>
            </div>
        </div>

        <button class="footer" @click="JumpFn">
          <template v-if="!showNew">
            <img class="img" :src="buttonList.footer">
            <div class="iconBox" v-if="activity.isShow">
                <img class="icon" :src="activity.PCicon">
            </div>
          </template>
          <template v-if="showNew">
            <div class="text-loop">
              <TextLoop :userInfoList="userInfoList" v-if="userInfoList.length" />
            </div>
              <img class="img" src="https://s20.lgstatic.com/growth/activity/20210825/1629890227855.png" alt="">
          </template>
        </button>
    </div>
</template>

<script>
import Swiper from 'swiper';
import 'swiper/dist/css/swiper.css';
import { handleJumpUrl } from '../../../uitl/getParam.js';
import list from './list'
import activity from '../../../common/activity';
import mixin from '../../../common/js/mixins/repurchase'
import { fetchUserInfo, judgeSubmit, privateEducationV2, subjectList } from '../../../service/api'
export default {
    mixins: [mixin],
    data() {
        return {
            list,
            activity,
            imgList:[],
            buttonList:{},
            titleList:{},
            swiperList:[],
            imgList1:[],
            studentList:[],
            courseId: 68,
            showMask: false,
            time: 5,
            userInfo: {},
            subjectList: [],
            key: "96e584784cb94c178ea397db3e409117",
            currentSubjectId: 1,
            submitted: false
        }
    },
    mounted () {
        setTimeout(()=>{
          if(this.isAB) {
            this.eduPlatTrack('WebView', { page_id: 'k1sah', page_from: '大课学习页'});
          } else {
            this.eduPlatTrack('WebView', { page_id: 'k1sah'});
          }
        },500)

        let dataList = this.list.data.pc;
        this.imgList = dataList.imgList
        this.buttonList = dataList.buttonList
        this.titleList = dataList.title
        this.swiperList = dataList.swiperList
        this.imgList1 = dataList.imgList1
        this.studentList = dataList.studentList

        this.renderSwiper()
        this.renderSwiperFn()
        this.hasSubmit()
        this.getSubjectList()
    },
    methods: {
        getSubjectList() {
            subjectList().then(res => {
                if (res.state == 1) {
                    this.subjectList = res.content || []
                    const defaultSubject = this.subjectList.find(item => item.isDefault);
                    this.currentSubjectId = defaultSubject.subjectId;
                }
            })
        },
        async hasSubmit() {
            const { state, content = {} } = await fetchUserInfo();
            if (state == 1) {
                this.userInfo = content;
                if (!content || !content.hasPhone) return;
                const { state: innerState, content: innerContent = {} } = await judgeSubmit({ formId: "146" });
                if (innerState == 1) {
                    this.submitted = innerContent.submitted;
                }
            }
        },
        handleCutdownTime() {
            if (this.time == 0) {
                this.showMask = false;
                this.time = 5;
                this.handleSubmit();
                return;
            }
            setTimeout(() => {
                this.time--;
                this.handleCutdownTime();
            }, 1000)
        },
        renderSwiper() {
            setTimeout(() => {
                let modify = 0;
                let translate = 0;
                let scale = 0;
                const swiper = new Swiper('.current-wrap', {
                    autoplay: 3200,
                    loop: true,
                    slidesPerView: 'auto',
                    loopedSlides: 4,
                    pagination: '.current-pagination',
                    paginationClickable: true,
                    watchSlidesProgress: true,
                    centeredSlides: true,
                    onSetTransition: (swiper, transition) => {
                        for (let i = 0; i < swiper.slides.length; i++) {
                            let slide = swiper.slides.eq(i);
                            slide.transition(transition);
                        }
                    },
                });
                swiper.on('progress', () => {
                    for (let i = 0; i < swiper.slides.length; i++) {
                        let slide = swiper.slides.eq(i);
                        let slideProgress = swiper.slides[i].progress;
                        modify = 1;
                        if (Math.abs(slideProgress) > 1) {
                            modify = (Math.abs(slideProgress) - 1) * 0.3 + 1;
                        }
                        translate = slideProgress * modify * 460 + 'PX';
                        scale = 1 - Math.abs(slideProgress) / 5;
                        let zIndex = 999 - Math.abs(Math.round(10 * slideProgress));
                        slide.transform('translateX(' + translate + ') scale(' + scale + ')');
                        slide.css('zIndex', zIndex);
                    }
                });
            }, 500);
        },
        renderSwiperFn() {
            setTimeout(() => {
                let modify = 0;
                let translate = 0;
                let scale = 0;
                const swiper = new Swiper('.student-wrap', {
                    autoplay: 2900,
                    loop: true,
                    slidesPerView: 'auto',
                    loopedSlides: 4,
                    // pagination: '.student-pagination',
                    paginationClickable: true,
                    watchSlidesProgress: true,
                    centeredSlides: true,
                    onSetTransition: (swiper, transition) => {
                        for (let i = 0; i < swiper.slides.length; i++) {
                            let slide = swiper.slides.eq(i);
                            slide.transition(transition);
                        }
                    },
                });
                // swiper.on('progress', () => {
                //     for (let i = 0; i < swiper.slides.length; i++) {
                //         let slide = swiper.slides.eq(i);
                //         let slideProgress = swiper.slides[i].progress;
                //         modify = 1;
                //         if (Math.abs(slideProgress) > 1) {
                //             modify = (Math.abs(slideProgress) - 1) * 0.3 + 1;
                //         }
                //         translate = slideProgress * modify * 300 + 'PX';
                //         console.log(modify, translate)
                //         scale = 1 - Math.abs(slideProgress) / 5;
                //         let zIndex = 999 - Math.abs(Math.round(10 * slideProgress));
                //         slide.transform('translateX(' + translate + ') scale(' + scale + ')');
                //         slide.css('zIndex', zIndex);
                //     }
                // });
            }, 500);
        },
        handleSubmit() {
            privateEducationV2({
                formId: "146",
                subjectId: this.currentSubjectId
            }).then(res => {
                const { state, content } = res || {}
                if (state == 1) {
                    content.retcode == 0 && handleJumpUrl(this.key)
                }
            }).finally(() => {
                this.showMask = false;
            })
        },
        handleChangeSubject(subjectId) {
            this.currentSubjectId = subjectId;
        },
        JumpFn() {
            if(this.showNew) {
                this.eduPlatTrack('WebButtonClick', {
                    'page_id': 'k1sah',
                    'courses_id': [this.courseId+''],
                    'button_name': '试学申请'
                });
            } else {
                this.eduPlatTrack('WebButtonClick', {
                    'page_id': 'k1sah',
                    'button_name': '领取详细课程大纲'
                });
            }
            if (!this.userInfo || !this.userInfo.hasPhone) {
                handleJumpUrl(this.key);
            } else {
                if (this.submitted) {
                    handleJumpUrl(this.key);
                } else {
                    this.showMask = true;
                    this.handleCutdownTime();
                }
            }
        }
    },
}
</script>

<style lang="less" scoped>
.container {
    width: 100%;
    position: relative;
    background: linear-gradient(360deg, #EAEBFA 0%, #F3F4FF 100%);
    padding-bottom: 140PX;
    .section {
        position: relative;
        width: 100%;
        min-width: 1200PX;
        &-cur {
            height: 795PX;
            .img {
                height: 795PX;
            }
        }
        &-stu {
            height: 1176PX;
            .img {
                height: 1176PX;
            }
        }
        .img {
            width: 100%;
            display: block;
        }
        .btn-more {
            position: absolute;
            left: 50%;
            transform: translate(-50%);
            bottom: 16PX;
            width: 464PX;
            height: 87PX;
            background-color:transparent;
            border: none;
            z-index: 9;
            cursor: pointer;
            img {
                width: 100%;
                display: block;
            }
        }
        .activityBox {
            position: absolute;
            top: 0;
            left: 50%;
            transform: translate(-50%);
            width: 950PX;
            height: 150PX;
        }
        .activityImg {
            display: block;
            float: right;
            width: 104PX;
            height: 133PX;
        }
    }
    .section-sw {
        position: absolute;
        top: 3%;
        width: 100%;
        margin-top: 40PX;
        min-width: 1200PX;
        // background: #F3F4FF;
        padding: 1PX 0 80PX;
        .title {
            margin: 0 auto 50PX;
            width: 667PX;
            img {
                width: 100%;
            }
        }
        @media screen and (max-width:1920px){
            .title {
                width: 600PX;
            }
        }
        @media screen and (max-width:1600px){
            .title {
                width: 500PX;
            }
        }
        @media screen and (max-width:1366px){
            .title {
                width: 400PX;
            }
        }
        /deep/ .current-wrap {
            width: 1200PX;
            height: 436PX;
            .swiper-slide {
                width: 655PX;
                opacity: 0;
                img {
                    display: block;
                    width: 655PX;
                    margin: 0 auto;
                }
                &.swiper-slide-active {
                    opacity: 1;
                }
                &.swiper-slide-next, &.swiper-slide-prev {
                    opacity: .5;
                }
            }
            .swiper-pagination {
                bottom: 0PX;
            }
            .swiper-pagination-bullet{
                width: 10PX;
                height: 10PX;
                background: linear-gradient(312deg, #7C1C33 0%, #1E1C54 100%);
                border-radius: 50%;
                opacity: .5;
                &-active{
                    border-radius: 12PX;
                    width: 24PX;
                    background: linear-gradient(312deg, #7C1C33 0%, #1E1C54 100%);
                    opacity: 1;
                }
            }
        }
    }
    .section-student {
        position: absolute;
        top: 3%;
        width: 100%;
        min-width: 1200PX;
        // background: #F3F4FF;
        padding: 1PX 0 50PX;
        .title {
            width: 1100PX;
            margin: 0 auto 30PX;
            img {
                width: 100%;
            }
        }
        @media screen and (max-width:1920px){
            .title {
                width: 1000PX;
            }
        }
        @media screen and (max-width:1600px){
            .title {
                width: 900PX;
            }
        }
        @media screen and (max-width:1366px){
            .title {
                width: 800PX;
            }
        }
        /deep/ .student-wrap {
            width: 1200PX;
            height: 869PX;
            .swiper-slide {
                width: 405PX;
                opacity: 0;
                img {
                    display: block;
                    width: 405PX;
                    margin: 0 auto;
                }
                &.swiper-slide-active {
                    opacity: 1;
                    transform: scale(1);
                }
                &.swiper-slide-next, &.swiper-slide-prev {
                    opacity: .5;
                    transform: scale(.85);
                }
            }
            .swiper-pagination {
                bottom: 0PX;
            }
            .swiper-pagination-bullet{
                width: 10PX;
                height: 10PX;
                background: linear-gradient(312deg, #7C1C33 0%, #1E1C54 100%);
                border-radius: 50%;
                opacity: .5;
                &-active{
                    border-radius: 12PX;
                    width: 24PX;
                    background: linear-gradient(312deg, #7C1C33 0%, #1E1C54 100%);
                    opacity: 1;
                }
            }
        }
    }
    .footer {
        position: fixed;
        background-color:transparent;
        border: none;
        bottom: -1PX;
        left: 50%;
        transform: translate(-50%);
        z-index: 999;
        width: 100%;
        .img {
            width: 100%;
            display: block;
        }
        .iconBox {
            position: absolute;
            top: -30PX;
            left: 50%;
            transform: translate(-50%);
            z-index: 9999;
            width: 940PX;
            .icon {
                float: right;
                width: 134PX;
            }
        }
        .text-loop {
          position: absolute;
          width: 215PX;
          height: 37PX;
          right: 31.5%;
          top: 50%;
          transform: translateY(-50%);
          border: none;
          border-image-width: 0;
        }
    }
}
.form-mask {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, .5);
    z-index: 9999;
    .mask-content {
        position: absolute;
        left: 50%;
        top: 40%;
        transform: translate(-50%, -50%);
        width: 600PX;
        height: 304PX;
        background-color: #fff;
        border-radius: 4PX;
        overflow: hidden;
        box-sizing: border-box;
        .mask-header {
            display: flex;
            width: 100%;
            height: 45PX;
            line-height: 45PX;
            box-sizing: border-box;
            font-size: 16PX;
            padding: 0 36PX 0 24PX;
            font-family: PingFangSC-Medium, PingFang SC;
            color: #333333;
            align-items: center;
            border-bottom: 1px solid #E8E9EB;
            justify-content: space-between;
            .time {
                height: 45PX;
                line-height: 45PX;
                font-size: 16PX;
                color: #E5A817;
            }
        }
        .subject-content {
            display: flex;
            width: 100%;
            padding: 35PX 0 0 24PX;
            flex-wrap: wrap;
            box-sizing: border-box;
            .subject-item {
                width: 123PX;
                height: 32PX;
                border-radius: 2PX;
                line-height: 32PX;
                text-align: center;
                background-color: #fff;
                font-size: 14PX;
                font-family: PingFangSC-Regular, PingFang SC;
                color: #333333;
                margin-bottom: 16PX;
                box-sizing: border-box;
                border: 1PX solid #E8E9EB;
                margin-right: 16PX;
                cursor: pointer;
                &.actived {
                    border: 1PX solid #FCD766;
                    background-color: rgba(252, 215, 102, 0.04);
                    color: #E5A817;
                }
            }
        }
        .mask-btn {
            float: right;
            width: 99PX;
            height: 40PX;
            line-height: 40PX;
            text-align: center;
            background-color: #FCD766;
            border-radius: 2PX;
            font-size: 16PX;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: bold;
            color: #333333;
            margin-right: 36PX;
            margin-top: 61PX;
            cursor: pointer;
        }
    }
}
</style>
